// api.ts
import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.PROD ? 'https://api.forms.3halves-labs.com' : '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': import.meta.env.VITE_API_KEY || 'oeO1RHGAD81SGBRPGVBwSg0qdIDhVggxvoGGGjAp9kkWayDj25lIkuvpZbuMyD621bi5BZZFuHIAJTUU122KyQrj8zjj8nh3GUcAzYkguhXYJUQHDMRxdP3c8Rqlu8ui'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      headers: config.headers,
      data: config.data ? 'Data present' : 'No data'
    });
    
    // Add auth token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      status: response.status,
      statusText: response.statusText,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('API Error Response:', {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      data: error.response?.data
    });
    
    if (error.response?.status === 401) {
      // Handle unauthorized - remove token and redirect
      localStorage.removeItem('authToken');
      // Don't redirect on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;